<template>
    <div>
        <img class="centerLeft" :src="this.getCue()" v-if ="phase === 'Cue'"/>  <!-- style = "position: absolute; left: 276px; top: 362px;" / -->
        <img class="centerRight" :src="this.getProbe()" v-if ="phase === 'Probe'"/>  <!-- style = "position: absolute; left: 548px; top: 362px;"/ -->
        <img class="center" src="../assets/optimal_fixation.png"/>  <!-- style = "position: absolute; left: 483px; top: 355px;"/ -->
        <!-- button
          type="button"
          name="endInstructions"
          class="btn btn-secondary"
          style="right: 20px; bottom: 20px; position: absolute;"
          @click="end()">End</button -->
        <div class="centerbox">
           <b-alert variant="warning" :show ="outcome === 'Correct'" class='centerOutcome col text-center'>+ 1 point</b-alert>
           <b-alert variant="primary" :show ="outcome === 'Respond Faster'" class='centerOutcome col text-center'>Respond Faster</b-alert>
           <b-alert variant="primary" :show ="outcome === 'Incorrect'" class='centerOutcome col text-center'>+ 0 points</b-alert>
        </div>
        <div style = "display: none">
          <img class="centerImage" rel="prefetch" :src="getTrialCues['cue1']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialCues['cue2']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialCues['cue3']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialCues['cue4']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialCues['cue5']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialCues['cue6']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialCues['cue7']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialCues['cue8']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe1']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe2']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe3']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe4']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe5']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe6']"/>
          <img class="centerImage" rel="prefetch" :src="getTrialProbes['probe7']"/>
        </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import * as Mousetrap from 'mousetrap'
  import * as _ from 'lodash'
  import State from '../mixins/State'
  export default {
    mixins: [ State ],
    data: () => {
      return {
        timer: undefined,
        keyCode1: undefined,
        keyCode2: undefined,
        start_time: undefined,
        response_time: null,
        end_time: undefined,
        responded: false,
        timeout: false,
        phase: "Cue",
        outcome: ""
      }
    },
    computed: {
      ...mapGetters(['getTrainingTrial']),
      ...mapGetters(['getCorrectAudio', 'getIncorrectAudio', 'getNoResponseAudio', 'getTrialCues', 'getTrialProbes']),
      ...mapState({
        cue_duration: state => state.parameters.cue_duration,
        probe_duration: state => state.parameters.probe_duration,
      })
    },
    mounted () {
      this.start_time = Date.now() // component start time
      // binds a handler to the left and right keys
      Mousetrap.bind(['left','1', 'up','right','2','3'], _.once((e) => {
        // record the response and reaction time in ms
        this.keyCode1 = e.keyCode
        if(this.keyCode1 == 49) {
          this.keyCode1 = 37
        }
        else if(this.keyCode21 == 50) {
            this.keyCode1 = 38
          }
        else if(this.keyCode1 == 51) {
            this.keyCode1 = 39
        }
        this.response_time = Date.now() - this.start_time
        this.responded = true
      }))
  
      this.timer = setTimeout(() => {
        this.phase = 'Focus'
      }, this.cue_duration)
  
      this.timer = setTimeout(() => {
        // check for a cue response and/or timeout
        this.end_time = Date.now()
        if (!this.responded){
            this.training_response({ r: 'timeout', remaining_time: 0, start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'training_cue' })
        }else{
            this.training_response({ r: this.keyCode1, remaining_time: 0, start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'training_cue' })
            this.responded = false
        } 
        this.phase = 'Probe'
        Mousetrap.unbind(['left','1', 'up','right','2','3'])
        Mousetrap.bind(['up','right','2','3'], _.once((e) => {
          // record the response and reaction time in ms
          this.keyCode2 = e.keyCode
          if(this.keyCode2 == 50) {
            this.keyCode2 = 38
          }
          if(this.keyCode2 == 51) {
            this.keyCode2 = 39
          }
          this.response_time = Date.now() - this.start_time
          this.responded = true
        }))
      }, this.cue_duration + 1100)
  
      this.timer = setTimeout(() => {
        this.phase = 'Focus'
      }, this.cue_duration + 1100 + this.probe_duration)
  
      this.timer = setTimeout(() => {
        this.end_time = Date.now()
        if (!this.responded){
            this.training_response({ r: 'timeout', remaining_time: 0, start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'training_probe' })
        }else{
            this.training_response({ r: this.keyCode2, remaining_time: 1100 - (this.end_time - this.start_time), start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'training_probe' })
            this.responded = false
        } 
        this.phase = 'Outcome'
        Mousetrap.unbind(['up','right','2','3'])
        if (this.keyCode1 == 37) {
          // this.outcome = "Correct"
          if (this.keyCode2 == 38) {
            if (this.getTrainingTrial[0] === "A" && this.getTrainingTrial[1] === "X") {
              this.outcome = "Correct"
            } else {
              this.outcome = "Incorrect"
            }
          } else if (this.keyCode2 == 39) {
            if (this.getTrainingTrial[0] === "A" && this.getTrainingTrial[1] === "X") {
              this.outcome = "Incorrect"
            }
            else {
              this.outcome = "Correct"
            }
          } else {
            this.outcome = "Respond Faster"
          }
        } else if (this.keyCode1 == 38 || this.keyCode1 == 39) {
          this.outcome = 'Incorrect'
        } else {
          this.outcome = 'Respond Faster'
        }
  
  
        var audio
        if (this.outcome === 'Correct') {
          audio = new Audio(this.getCorrectAudio)
          // this.sendSerial(5)
        } else if (this.outcome === 'Incorrect') {
          audio = new Audio(this.getIncorrectAudio)
          // this.sendSerial(6)
        } else {
          audio = new Audio(this.getNoResponseAudio)
          // this.sendSerial(7)
        }
        audio.play()
      }, this.cue_duration + 1100 + this.probe_duration + 1100)
  
      this.timer = setTimeout(() => {
        this.phase = 'Focus'
      this.end_time = Date.now()
      this.training_response({ outcome: this.outcome, r: null, start_time: this.start_time, end_time: this.end_time, response_state: 'training_outcome' })
        this.outcome = ''
      }, this.cue_duration + 1100 + this.probe_duration + 1100 + 500)
  
      this.timer = setTimeout(() => {    
        this.increment_training()
        this.$router.replace("/training_outcome")
      }, this.cue_duration + 1100 + this.probe_duration + 1100 + 500 + 2400)
    },
    beforeDestroy () {
      // clear the timer when the cue state is left
      clearTimeout(this.timer)
      Mousetrap.unbind(['up','right','2','3'])
      // this.response({ r: null, remaining_time: 0, start_time: this.start_time, response_time: this.response_time, end_time: this.end_time, response_state: 'training_outcome_focus' })
    },
    methods: {
      ...mapActions(['training_response', 'setStartTime','increment_training']),
      end: function () {
        clearTimeout(this.timer)
        this.$router.replace('/instructions/5')
      },
      getCue: function() {
        console.log(this.getTrainingTrial)
        if (this.getTrainingTrial[0] === "A") {
          // return '/img/A_100_2p50c.ad244a52.png'
          return this.getTrialCues['cue1']
        }
        else {
          // return '/img/B_010_2p50c.c7469fef.png'
          return this.getTrialCues['cue2']
        }
      },
      getProbe: function() {
        if (this.getTrainingTrial[1] === "X") {
          // return '/img/X_055_1p20c.1038f956.png'
          return this.getTrialProbes['probe1']
        }
        else {
          // return '/img/Y_024_0p60c.b34391cc.png'
          return this.getTrialProbes['probe2']
        }
      }
    }
  }
  </script>